<template>
  <Modal position="end" ref="modalRef">
    <template #header>Parking</template>
    <template #body>
      <PropertyParkingForm ref="formRef" />
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close">Cancel</Button>
      <Button @click="save" :loading="formRef?.form.submitting">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Modal, Button } from '@tallo/design-system';
import { PropertyParkingForm } from '@tallo/investor/property';

const modalRef = ref<InstanceType<typeof Modal>>();
const formRef = ref<InstanceType<typeof PropertyParkingForm>>();

async function save() {
  await formRef.value?.save();

  modalRef.value?.close();
}

defineExpose({ modalRef });
</script>
